<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div>
        <div class="comp-risk-ques">
            <el-row class="risk-test">
                <el-col class="risk-ques" :span="24">
                    <div class="risk-header">
                        <div class="ques-tit">
                            <span>{{ index }}</span>
                            /{{ riskQuestions.length }}
                            <span class="ques-multi">
                                {{ doQuestion.multselect === "1" ? "多选" : "单选" }}
                            </span>
                            <span class="ques-text margin-left-40">
                                {{ doQuestion.questionname }}
                            </span>
                        </div>
                        <div class="ques-box">
                            <div class="ques-list">
                                <el-radio-group
                                    v-if="doQuestion.multselect === '0'"
                                    v-model="answer"
                                >
                                    <el-radio
                                        v-for="(an, _x) in doQuestion.resultList"
                                        :key="_x"
                                        :label="an.result"
                                        class="color-666"
                                    >
                                        {{
                                            /[a-zA-Z]+$/.test(an.resultcontent.substr(0, 2))
                                                ? an.resultcontent
                                                : an.result + "、" + an.resultcontent
                                        }}
                                    </el-radio>
                                </el-radio-group>
                                <el-checkbox-group
                                    v-if="doQuestion.multselect === '1'"
                                    v-model="answerArr"
                                >
                                    <el-checkbox
                                        v-for="(an, _y) in doQuestion.resultList"
                                        :key="_y"
                                        :label="an.result"
                                        class="color-666"
                                    >
                                        {{ an.resultcontent }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <el-row class="ques-next">
                                <el-button
                                    class="btn-prev"
                                    :disabled="index === 1"
                                    @click="questionRefresh(index - 1)"
                                >
                                    上一题
                                </el-button>
                                <el-button
                                    class="btn-next"
                                    :disabled="!isAnswered || index === riskQuestions.length"
                                    @click="questionRefresh(index + 1)"
                                >
                                    下一题
                                </el-button>
                            </el-row>
                        </div>
                    </div>
                    <el-row v-if="riskQuestions.length > 0" class="answer-list">
                        <el-col class="answer-list-title">答题卡</el-col>
                        <el-col v-for="(list, _z) in riskQuestions" :key="_z" :span="12">
                            <div class="answer-list-answer" v-on:click="questionRefresh(_z + 1)">
                                {{ _z + 1 }}.
                                <span>{{ list.key }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <!-- <div class="agree-content">
                    <el-checkbox v-model="checked">
                    </el-checkbox>
                    <span>本人已仔细阅读贵司的<a class="notice-read" v-on:click.prevent="read()">《投资者类型及风险匹配告知书》</a>，已充分知晓并理解贵司对本人的风险承受能力评估及产品等级匹配结果，本人对此没有异议。
                        <br />本人承诺，将及时、如实地向贵司告知本人的重大信息变更。
                    </span>
                </div> -->
                </el-col>
            </el-row>

            <el-dialog
                title="提示"
                :visible.sync="tpasswdDialogVisible"
                class="prop info-tips"
                width="480px"
            >
                <div class="investor-tips">
                    <div class="prompt-info">
                        <p>
                            <i class="el-icon-warning" aria-hidden="true" />
                            <span>普通投资者转专业投资需要密码校验</span>
                        </p>
                    </div>
                    <el-form
                        ref="ruleForm"
                        class="two-cols-form"
                        :model="ruleForm"
                        :rules="rules"
                        label-width="37px"
                        size="small"
                    >
                        <el-form-item label="" prop="tpasswd">
                            <el-input
                                v-model="ruleForm.tpasswd"
                                type="password"
                                :maxlength="20"
                                placeholder="请输入交易密码"
                            />
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button v-on:click="tpasswdDialogVisible = false">返回</el-button>
                    <el-button type="primary" v-on:click="cancelConfirm">确定</el-button>
                </div>
            </el-dialog>
            <el-dialog
                :title="(data.risk ? '风险' : '知识') + '评测提示'"
                :visible.sync="dialogVisible"
                class="prop"
                width="420px"
            >
                <div class="info-box">
                    <el-alert :title="msg" type="warning" show-icon :closable="false" />
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button
                        v-if="passflag === '0'"
                        v-on:click="$router.push({ name: 'acctManager' })"
                    >
                        信息中心
                    </el-button>
                    <el-button type="primary" v-on:click="dialogVisible = false">
                        {{ btnMsg }}
                    </el-button>
                </div>
            </el-dialog>
            <el-dialog
                title="投资者类型及风险匹配告知书"
                :visible.sync="noticeDialogVisible"
                :fullscreen="true"
            >
                <div>
                    尊敬的投资者：
                    <br />
                    <br />
                    &emsp;&emsp;公开募集证券投资基金或私募资产管理计划（以下统称“产品”）是一种长期投资工具，其主要功能是分散投资，降低投资单一证券所带来的个别风险。产品不同于银行储蓄、国债等能够提供固定收益预期的金融工具，其投资运作过程中可能会面临各种风险，如市场风险、信用风险、流动性风险等，因此投资运作既可能产生收益，也可能产生损失（本金亏损或超过原始本金损失）。一般来说，产品的收益预期越高，投资者承担的风险也越大。由于与产品有关的文本（如产品合同、产品说明书/招募说明书（更新）、公告等）除明确产品投资范围、投资限制等还可能存在解除合同等限制性条款或对投资者行使权力有相关要求。因此，敬请投资者投资产品前认真阅读拟投资产品的产品合同、产品说明书/招募说明书、公告等与产品有关的文本，充分了解投资者的权利、义务以及该产品的风险收益特征，根据自身投资目的、风险偏好、投资经验及风险承受能力审慎选择适合自己的产品。
                    <br />
                    &emsp;&emsp;产品投资过程中除面临上述风险外，对于开放式或定期开放式产品，其运营过程中还会面临特有的巨额赎回风险，即当单个交易日产品的净赎回申请超过产品总份额一定比例时，将无法及时满足所有投资者的赎回申请。敬请投资者根据其投资期限、资产状况等判断此类产品是否与自己的风险承受能力相适应。此外，管理人业务或财务状况的变化，也可能对投资运作产生不利影响，从而使投资者承受因此产生的投资损失。敬请投资者审慎选择管理人，避免因管理人原因而影响自身合理判断。
                    <br />
                    &emsp;&emsp;本公司坚持投资者利益优先原则，在销售产品的过程中将基于投资者的不同风险承受能力以及产品的不同风险等级等因素，提出明确的适当性匹配意见。本公司的适当性匹配意见不表明对产品的风险和收益做出实质性判断或者保证。本公司提醒投资者产品投资的“卖者尽责，买者自负”原则，在做出投资决策后，产品运营状况与产品净值变化引致的投资风险，由投资者自行负担。
                    <br />
                    &emsp;&emsp;本风险告知函的揭示事项仅为列举性质，未能详尽列明投资者投资产品所面临的全部风险和可能导致投资者资产损失的所有因素。投资者应当认真阅读《基金合同》、《招募说明书》、《产品资料概要》或《私募资产管理合同》、《私募资产管理计划说明书》等法律文件，充分了解产品情况及风险收益特征，听取本公司适当性匹配意见的基础上，请投资者根据自身风险承受能力审慎决策，独立承担投资风险。
                    <br />
                    &emsp;&emsp;本公司作为管理人承诺以诚实信用、勤勉尽责的原则管理和运用产品资产，但不保证产品一定盈利，也不保证最低收益。产品的过往业绩及其净值高低并不预示其未来业绩表现。
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" v-on:click="makesureSubmit()">
                        我已阅读并知晓
                    </el-button>
                </div>
            </el-dialog>
        </div>
        <div class="ques-btn">
            <el-button class="submit-btn" v-on:click="submitForm()">提交问卷</el-button>
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
        <risk-confirm-dialog
            :risk-level="predictLevel"
            :visible="resultConfirmDialogVisible"
            v-on:confirm="resultConfirm"
            v-on:cancel="resultCancel"
        ></risk-confirm-dialog>
    </div>
</template>
<script>
import userApi from "@/api/user";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import RiskConfirmDialog from "@/bizcomponents/acctManager/riskConfirmDialog.vue";

export default {
    name: "RiskQues",
    components: {
        RiskConfirmDialog,
        footerQuestions
    },
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    risk: true,
                    url: "risk"
                };
            }
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            agree: "",
            answer: "",
            answerArr: [],
            btnMsg: "",
            index: 1,
            query: null, // 定时器对象
            riskQuestions: [],
            doQuestion: {},
            msg: "",
            passflag: "",
            checked: true,
            noticeDialogVisible: false,
            // 密码校验
            ruleForm: {
                tpasswd: ""
            },
            rules: {
                tpasswd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            tpasswdDialogVisible: false,
            warningHtml: "",
            commonQuestion: [],
            firstriskdayflag: "",
            assettype: "",
            resultConfirmDialogVisible: false,
            predictLevel: "",
            needResultConfirm: false
        };
    },
    computed: {
        isAnswered() {
            // 单选题：answer 不为空；多选题：answerArr 长度大于0
            return this.doQuestion.multselect === "0"
                ? !this.$util.isEmpty(this.answer)
                : !this.$util.isEmpty(this.answerArr) && this.answerArr.length > 0;
        }
    },
    watch: {
        answer(val) {
            // 监听答案更新数据
            if (val && val !== "") {
                const _this = this;
                if (
                    this.index < this.riskQuestions.length &&
                    val !== this.riskQuestions[this.index - 1].key
                ) {
                    // 自动跳到下一题
                    this.query = setTimeout(function () {
                        _this.questionRefresh(_this.index + 1);
                    }, 100);
                }
                this.$set(this.riskQuestions[this.index - 1], "key", val);
            }
        },
        answerArr(val) {
            if (val && val.length > 0) {
                this.$set(this.riskQuestions[this.index - 1], "key", val.join(","));
            }
        }
    },
    created() {
        this.firstriskdayflag = this.$route.query.firstriskdayflag || "1";
        this.assettype = this.$route.query.assettype || "*";
        this.getRisks();
        this.warningHtml = warningHtml.warningHtml14;
    },
    mounted() {
        this.needResultConfirm = this.$cache.getCompanyInfoParam("10102039") === "1";
    },
    methods: {
        async submitForm() {
            const _this = this;
            let _notDo = [];
            for (let _x in this.riskQuestions) {
                const _r = this.riskQuestions[_x].key;
                if (!_r) {
                    _notDo.push(Number(_x) + 1);
                }
            }
            if (_notDo.length > 0) {
                this.msg = "您还有第" + _notDo.join(",") + "题(共" + _notDo.length + "题)没有回答!";
                this.btnMsg = "我已知晓";
                this.dialogVisible = true;
            } else {
                if (this.needResultConfirm) {
                    await this.predictRisk();
                    this.resultConfirmDialogVisible = true;
                } else {
                    // this.noticeDialogVisible = true;
                    this.makesureSubmit();
                }
            }
        },
        async predictRisk() {
            let { allResult, allPoint } = this.computePoint();
            const res = await userApi.combRiskGardeQuery({
                answer: allResult.substr(0, allResult.length - 1),
                papercode: this.riskQuestions[0].papercode
            });
            if (res.code == "0") {
                this.predictLevel = res.data.custrisk;
            }
        },
        computePoint() {
            const _this = this;
            let allResult = "";
            let allPoint = "";
            _this.noticeDialogVisible = false;
            for (let _x in this.riskQuestions) {
                const _r = this.riskQuestions[_x].key;
                if (_r) {
                    allResult += this.riskQuestions[_x].questioncode + ":" + _r + "|";
                    const _a = this.riskQuestions[_x].resultList;
                    let point = [];
                    for (let _z in _a) {
                        if (_r.indexOf(_a[_z].result) > -1) {
                            point.push(_a[_z].resultpoint);
                        }
                    }
                    allPoint += point.join(",") + "|";
                }
            }
            return { allPoint, allResult };
        },
        async makesureSubmit() {
            const _this = this;
            let { allResult, allPoint } = this.computePoint();
            _this.noticeDialogVisible = false;
            try {
                if (this.data.risk) {
                    // this.firstriskdayflag = ""; // 临时代码
                    if (_this.firstriskdayflag !== "1") {
                        _this.combRiskGardeQuery(allResult, allPoint);
                    } else {
                        _this.combCustRiskService(allResult, allPoint);
                    }
                } else {
                    const res = await userApi.custKnowledgeRisk({
                        answer: allResult.substr(0, allResult.length - 1),
                        pointlist: allPoint.substr(0, allPoint.length - 1),
                        papercode: this.riskQuestions[0].papercode,
                        iscontinue: "1",
                        assettype: "*"
                    });
                    if (res.code == "0") {
                        _this.passflag = res.data.passflag;
                        if (_this.passflag === "1") {
                            // 投资者转换不支持校验交易密码
                            // if (_this.$cache.getPwdCheck("P2")) {
                            //     _this.ruleForm.tpasswd = "";
                            //     _this.tpasswdDialogVisible = true;
                            // } else {
                            //     _this.toProfessional();
                            // }
                            _this.toProfessional();
                        } else {
                            _this.msg = "您的投资者知识评测未达到要求";
                            _this.btnMsg = "重新评测";
                            _this.dialogVisible = true;
                        }
                    }
                }
            } catch (e) {
                this.$log.error(e);
            }
        },
        async combRiskGardeQuery(allResult, allPoint) {
            const _this = this;
            const res = await userApi.combRiskGardeQuery({
                answer: allResult.substr(0, allResult.length - 1),
                papercode: this.riskQuestions[0].papercode
            });
            if (res.code == "0") {
                const h = this.$createElement;
                if (
                    this.$route.query.risklevel &&
                    res.data.custrisk > this.$route.query.risklevel
                ) {
                    this.$msgbox({
                        title: "提示",
                        message: h("div", [
                            "是否因最近一次填写错误，造成需在短时间内第二次重评风险测评问卷？",
                            h("br"),
                            `选择确定，此次重评生效，您的风险等级为：${this.$cache.getDict(
                                "100017",
                                res.data.custrisk
                            )}。`,
                            h("br"),
                            `选择取消，此次重评不生效，您的风险承受能力等级仍为：${this.$cache.getDict(
                                "100017",
                                this.$route.query.risklevel
                            )}。`
                        ]),
                        showCancelButton: true,
                        confirmButtonText: "确定",
                        type: "warning",
                        customClass: "info-check",
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                _this.combCustRiskService(allResult, allPoint);
                                done();
                            } else {
                                done();
                            }
                        }
                    });
                } else {
                    _this.combCustRiskService(allResult, allPoint);
                }
            }
        },
        async combCustRiskService(allResult, allPoint) {
            const _this = this;
            let assettype = this.$util.getParamValue("1000056");
            const res = await userApi.combCustRiskService({
                answer: allResult.substr(0, allResult.length - 1),
                pointlist: allPoint.substr(0, allPoint.length - 1),
                papercode: this.riskQuestions[0].papercode,
                iscontinue: "1",
                assettype: assettype.indexOf(_this.assettype) > -1 ? _this.assettype : "*"
            });
            if (res.code == "0") {
                _this.$cache.refreshUser(() => {
                    if (
                        _this.fn &&
                        this.$route.query.assettype != "3" &&
                        this.$route.query.assettype != "" &&
                        this.$route.query.assettype != "*"
                    ) {
                        _this.$emit("fn-back", false);
                    } else {
                        _this.$router.push({
                            name: _this.data.url,
                            query: {
                                iswarn: res.data.iswarn,
                                assettype: _this.assettype,
                                risklevel: res.data.custrisk
                            }
                        });
                    }
                });
            }
        },
        cancelConfirm() {
            var _this = this;
            _this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    _this.tpasswdDialogVisible = false;
                    _this.toProfessional();
                } else {
                    return false;
                }
            });
        },
        toProfessional() {
            this.ruleForm.tpasswd = "";
            this.$router.push({ name: this.data.url });
        },
        // 刷新题目数据
        questionRefresh(val) {
            /* if(this.index === val){
                    return;
                } */
            clearTimeout(this.query);
            this.index = val;
            const _d = this.riskQuestions[this.index - 1];
            this.doQuestion = _d;
            this.answer = _d ? _d.key : "";
            this.answerArr = _d && _d.key && _d.key.length > 0 ? _d.key.split(",") : [];
        },
        // 获取题目信息
        async getRisks() {
            const _this = this;
            const papertype = this.data.risk ? "0" : "1";
            let assettype = this.$util.getParamValue("1000056");
            const res = await userApi.selectQuestionAndOption({
                invtp: this.$cache.getUser().invtp,
                status: "0",
                assettype: assettype.indexOf(_this.assettype) > -1 ? _this.assettype : "*",
                papertype: papertype
            });
            if (res.data) {
                let _obj = {};
                // 整理题目数据格式
                for (let arr of res.data) {
                    _this.riskQuestions.push(arr);
                }
            }
            _this.questionRefresh(_this.index);
        },
        resultCancel() {
            this.resultConfirmDialogVisible = false;
            this.predictLevel = "";
        },
        resultConfirm() {
            this.resultCancel();
            this.makesureSubmit();
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-risk-ques {
    border: 1px solid var(--color-border-base);
    margin-top: 20px;
    .risk-test {
        .btn-prev {
            width: 120px;
            height: 36px;
            border-radius: 2px;
            background: var(--color-accent) !important;
            color: var(--color-primary) !important;
            border: 1px solid var(--color-accent);
            &:disabled {
                background: var(--color-divided) !important;
                border: 1px solid var(--color-divided);
                color: var(--color-text-white) !important;
            }
        }
        .btn-next {
            width: 120px;
            height: 36px;
            border-radius: 2px;
            background: var(--color-primary) !important;
            color: var(--color-text-white) !important;
            border: 1px solid var(--color-primary);
            margin-left: 30px;
            &:disabled {
                background: var(--color-divided) !important;
                border: 1px solid var(--color-divided);
            }
        }

        padding: 0 0 0 20px;
        .risk-tit {
            margin: 20px 0 10px;
            .risk-tit-box {
                background-color: var(--color-bg-container);
                border: 1px solid var(--color-divided);
                padding: 8px 10px;
                .risk-icon {
                    width: 42px;
                    height: 48px;
                    display: inline-block;
                    vertical-align: middle;
                    background: url($icon) -297px -122px no-repeat;
                    margin-right: 13px;
                }
                span {
                    display: inline-block;
                    vertical-align: middle;
                    line-height: 24px;
                    color: var(--color-text-accent);
                    width: 1076px;
                }
            }
        }
        .risk-ques {
            display: flex;
            .risk-header {
                .ques-tit {
                    position: relative;
                    margin-top: 21px;
                    width: 900px;
                    padding-bottom: 17px;
                    border-bottom: 1px solid var(--color-border-base);
                    span {
                        color: var(--color-text-primary);
                        font-weight: 500;
                        font-size: 20px;
                    }
                    font-size: 14px;
                    color: var(--color-text-accent);
                    .ques-multi {
                        font-size: 12px;
                        border: 1px solid var(--color-primary);
                        padding: 2px 4px;
                        color: var(--color-primary);
                        position: absolute;
                        top: 3px;
                    }
                }
                .ques-next {
                    margin: 10px 0 20px 24px;
                }
                .ques-box {
                    .ques-list {
                        padding: 10px 0;
                        color: var(--color-text-regular);
                        .ques-text {
                            font-size: $f16;
                            line-height: 36px;
                        }
                        .el-radio-group,
                        .el-checkbox-group {
                            margin: 7px 0 10px 24px;
                            .el-radio,
                            .el-checkbox {
                                display: block;
                            }
                            .el-radio + .el-radio,
                            .el-checkbox + .el-checkbox {
                                margin-left: 0;
                                margin-top: 9px;
                            }
                        }
                    }
                }
            }
            .answer-list {
                width: 300px;
                border-radius: 6px;
                font-size: $f16;
                color: var(--color-text-primary);
                .answer-list-title {
                    text-align: center;
                    background: var(--color-bg-container);
                    font-size: 14px;
                    font-weight: 500;
                    color: var(--color-text-regular);
                }
                .answer-list-answer {
                    padding-left: 18px;
                    display: flex;
                    align-items: center;
                    span {
                        display: inline-block;
                        margin-left: 6px;
                        white-space: normal; // 允许换行
                        word-break: break-all; // 必要时强制断行
                        line-height: 20px;
                    }
                }
                .el-col {
                    line-height: 40px;
                    cursor: pointer;
                    padding: 0 4px;
                    border: 1px solid var(--color-border-base);
                }
            }

            .agree-content {
                padding: 15px 20px;
                > label {
                    margin-right: 7px;
                }
                .notice-read {
                    cursor: pointer;
                }
            }
        }
    }

    .margin-left-40 {
        margin-left: 40px;
    }
}
.ques-btn {
    margin-top: 30px;
    padding-bottom: 20px;
    .el-checkbox-group {
        margin: 10px 0;
    }
    .submit-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: var(--color-primary);
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: var(--color-text-white);
        border: none;
        cursor: pointer;
    }
}
.color-666 {
    color: var(--color-text-regular) !important;
}
</style>
